import React, { useState } from 'react';
import { breadcrumbsBem } from '../../components/breadcrumbs/breadcrumbs.constants';
import { DisciplineIcon } from '@om-fe/widgets/dist/components/icon/discipline-icon';
import { useI18n } from '@om-fe/widgets/dist/common/i18n/i18n.hooks';
import { GeneralIcon } from '@om-fe/widgets/dist/components/icon/general-icon';
import { RouteNames } from '@om-fe/core/core/routing/utils';
import Anchor from '@om-fe/core/components/anchor/anchor';
import { DisciplinesType } from '@om-fe/models';
import BottomDrawer from '@om-fe/core/components/bottom-drawer/bottom-drawer';
import { NextRaceEventListLoadLazy } from '@om-fe/core/core/widgets/omfe-widgets';

interface NextRaceBreadcrumbsProps {
  readonly isLarge?: boolean;
  readonly deviceType: string;
  readonly sportId: string;
}

const lang = 'en-GB';

export const NextRaceBreadcrumbs = ({
  isLarge = false,
  deviceType,
  sportId
}: NextRaceBreadcrumbsProps) => {
  const { gettext } = useI18n();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen)
  }

  return (
    <>
    <div className={breadcrumbsBem()} onClick={!isLarge ? toggleDrawer : undefined}>
        <Anchor
            routeName={RouteNames.home}
            className={breadcrumbsBem('BackButton')}
            title={gettext('Home')}
        >
            {!isLarge ? (
                <>
                <GeneralIcon name='arrow-big-back'/>
                </>
              ) : <span>{gettext('Home')}</span>
            }
        </Anchor>
        {!isLarge && (
          <>
          <div className={breadcrumbsBem('Flags')}>
          <DisciplineIcon disciplineId={sportId} />
          </div>
          <span className={breadcrumbsBem('EventName')}>
            {sportId === DisciplinesType.HorseRacing ? gettext('Horse Racing') : sportId === DisciplinesType.GreyHounds ? gettext('Greyhounds') : null}
          </span>
          <GeneralIcon name={isDrawerOpen ? 'arr-up' : 'arr-down'} />
          </>
        )}
    </div>
    {isDrawerOpen && (
      <BottomDrawer onClose={toggleDrawer}>
        <NextRaceEventListLoadLazy lang={lang} deviceType={deviceType} sportId={sportId} />
      </BottomDrawer>
    )}
    </>
  );
}